/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCardSd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M20 2v20H6.465L4 19.302v-3.921l2-1V13H4V8.382l2-1.001V2zm-1.999 2H8v4.618l-2 1V11h2v4.618l-2 1v2.079L7.535 20h10.466zm-6 2v5h-2V6zm4 0v5h-2V6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCardSd as CardSd };
